'use client';

import { Box, Typography } from '@mui/material';
import { Category } from '@mui/icons-material';
import {
  api_portalOfficeListing_filter,
  ibow2_proto_PortalOfficeListingService,
} from '@/init/swagger';
import { useLogic } from './logic';

type Props = {
  services: ibow2_proto_PortalOfficeListingService[];
  searchFilters: api_portalOfficeListing_filter[];
};

export function ServiceList({ services, searchFilters }: Props) {
  const { serviceCategoryItems, hasServiceCategoryItems } = useLogic({
    services,
    searchFilters,
  });

  if (!hasServiceCategoryItems) {
    return null;
  }

  const serviceText = serviceCategoryItems
    .map((service) => service.label)
    .join('・');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Category
        sx={{
          fontSize: 18,
          color: '#595960',
        }}
      />
      <Typography color="#595960" variant="JP/Body/m/Regular/Normal">
        {serviceText}
      </Typography>
    </Box>
  );
}
